module.exports = __webpack_public_path__ + "static/media/Location.188ef20f.svg";